import { useState, useEffect } from 'react';
import { Task } from '@/types/tasks';

/**
 * Hook to manage local task state
 */
export const useLocalTaskState = (
  dbActiveTasks: Task[],
  dbCompletedTasks: Task[],
  isLoading: boolean,
  isChangingView: boolean,
  _workspaceError: boolean // Parameter kept for compatibility but not used
) => {
  const [localActiveTasks, setLocalActiveTasks] = useState<Task[]>([]);
  const [localCompletedTasks, setLocalCompletedTasks] = useState<Task[]>([]);
  
  // Update local state when db tasks change
  // Now that arrays are stable, this won't cause infinite loops
  useEffect(() => {
    if (isLoading && !isChangingView) {
      // Don't update during regular loading unless we have data
      if (dbActiveTasks.length > 0 || dbCompletedTasks.length > 0) {
        setLocalActiveTasks(dbActiveTasks);
        setLocalCompletedTasks(dbCompletedTasks);
      }
    } else {
      // Always update when not in loading state or during view changes
      // This ensures we display empty state correctly
      setLocalActiveTasks(dbActiveTasks);
      setLocalCompletedTasks(dbCompletedTasks);
    }
  }, [dbActiveTasks, dbCompletedTasks, isLoading, isChangingView]);
  
  return {
    localActiveTasks,
    localCompletedTasks,
    setLocalActiveTasks,
    setLocalCompletedTasks
  };
};
